module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG9645a6a9b6025270fbb9e8c4809e83c4.9645a6a9.png";